import { useContext } from 'react';

import { RootStoreContext } from 'src/contexts/RootStoreContext';
import { ERROR_MESSAGES } from 'src/utils/constants';

export const useStore = () => {
  const store = useContext(RootStoreContext);
  if (!store) {
    throw new Error(ERROR_MESSAGES.cannotUseStore);
  }
  return store;
};
